// ✅ Shopify Embedded Form Validation + Auto-fill (self-contained product modal)
//    Drop-in replacement for the 2nd IIFE in form-app.js
(function () {
  const wait = (ms) => new Promise((r) => setTimeout(r, ms));

  const customerData = {
    orders: window.CUSTOMER_ORDERS || [],
    customer: {
      firstName: window.CUSTOMER_FIRST_NAME || "",
      lastName: window.CUSTOMER_LAST_NAME || "",
      email: window.CUSTOMER_EMAIL || "",
      address: window.CUSTOMER_ADDRESS || {},
    },
  };

  // --- Inject modal styles once (light DOM, not shadow) ---
  (function injectModalStyles() {
    if (document.getElementById("wd-modal-styles")) return;
    const style = document.createElement("style");
    style.id = "wd-modal-styles";
    style.textContent = `
      .wd-modal-overlay {
        position: fixed; inset: 0; z-index: 99999;
        background: rgba(0,0,0,0.6);
        display: flex; align-items: center; justify-content: center;
        padding: 20px;
      }
      .wd-modal {
        background: rgb(231, 214, 199); color: #fff;
        border: 1px solid rgba(255,255,255,0.12); border-radius: 14px;
        width: 100%; max-width: 520px; max-height: 80vh; overflow-y: auto;
        padding: 28px; box-shadow: 0 12px 40px rgba(0,0,0,0.4);
      }
      .wd-modal__title { margin: 0 0 18px; font-size: 20px; font-weight: 700; text-align: center;color: #472222; }
      .wd-modal__rows { display: flex; flex-direction: column; gap: 12px; }
      .wd-modal__row {
        display: grid; grid-template-columns: auto 1fr auto auto; gap: 12px;
        align-items: center; padding: 12px 14px;
        background: #ffffff; border: 1px solid rgba(255,255,255,0.15); border-radius: 10px;
      }
      .wd-modal__check { width: 18px; height: 18px; accent-color: #e55d5a; ; cursor: pointer; }
      .wd-modal__label { font-size: 14px; color: #502c1e; }
      .wd-modal__max { font-size: 12px; color: rgba(255,255,255,0.55); white-space: nowrap; }
      .wd-modal__stepper { display: flex; align-items: center; gap: 6px; }
      .wd-modal__step {
        width: 30px; height: 30px; flex: 0 0 30px; border-radius: 8px;
        background: #502c1e;; border: 1px solid rgba(255,255,255,0.25); color: #fff;
        font-size: 18px; line-height: 1; cursor: pointer;
        display: flex; align-items: center; justify-content: center; padding: 0;
      }
      .wd-modal__step:disabled { opacity: 0.35; cursor: not-allowed; }
      .wd-modal__qty {
        width: 48px; padding: 8px 4px; border-radius: 8px; text-align: center;
        background: #502c1e; border: 1px solid rgba(255,255,255,0.2); color: #fff;
        -moz-appearance: textfield;
      }
      .wd-modal__qty::-webkit-outer-spin-button,
      .wd-modal__qty::-webkit-inner-spin-button { -webkit-appearance: none; margin: 0; }
      .wd-modal__qty:disabled { opacity: 0.4; }
      .wd-modal__actions { display: flex; gap: 12px; margin-top: 22px; }
      .wd-modal__btn {
        flex: 1; padding: 12px; border-radius: 50px; font-weight: 600;
        cursor: pointer; border: 1px solid transparent;
      }
      .wd-modal__btn--cancel { background: #e9eff5; border-color: rgba(255,255,255,0.25); color: #502c1e; text-align: center; }
      .wd-modal__btn--done { background: #e55d5a; color: #fff; text-align: center; }
      @media (max-width: 480px) {
        .wd-modal__row { grid-template-columns: auto 1fr; grid-auto-rows: auto; }
        .wd-modal__max, .wd-modal__stepper { grid-column: 2; justify-self: start; }
      }
    `;
    document.head.appendChild(style);
  })();

  // --- Error helpers ---
  function showError(field, message) {
    if (!field) return;
    const phoneContainer = field.closest("._formPhoneInputContainer_piv1u_6");
    const parent = phoneContainer || field.closest("._formFieldContainer_1mxsl_5") || field.parentElement;
    if (!parent) return;
    clearError(field);
    const err = document.createElement("div");
    err.className = "field-error-js";
    err.style.color = "#e02229";
    err.style.fontSize = "13px";
    err.style.marginTop = "8px";
    err.textContent = message;
    if (phoneContainer) { err.style.gridColumn = "1 / -1"; err.style.width = "100%"; }
    parent.appendChild(err);
    field.style.border = "1px solid #e02229";
  }

  function clearError(field) {
    if (!field) return;
    const phoneContainer = field.closest("._formPhoneInputContainer_piv1u_6");
    const parent = phoneContainer || field.closest("._formFieldContainer_1mxsl_5") || field.parentElement;
    if (!parent) return;
    const existing = parent.querySelector(".field-error-js");
    if (existing) existing.remove();
    field.style.border = "1px solid rgba(255,255,255,0.2)";
  }

  async function getShopifyFormRoot() {
    for (let i = 0; i < 50; i++) {
      const embed = document.querySelector("shopify-forms-embed");
      if (embed && embed.shadowRoot) {
        const form = embed.shadowRoot.querySelector("form");
        if (form) return embed.shadowRoot;
      }
      await wait(300);
    }
    return null;
  }

  async function initValidation() {
    const root = await getShopifyFormRoot();
    if (!root) return;

    const get = (sel) => root.querySelector(sel);
    const getFieldByLabel = (labelRegex) => {
      const fields = Array.from(root.querySelectorAll("input, textarea, select"));
      for (const field of fields) {
        const container =
          field.closest("._formFieldContainer_1mxsl_5") ||
          field.closest("._formFileInput_ehvsf_1") ||
          field.parentElement;
        const labelText = container?.querySelector("label, p._textBody_2aowh_10")?.textContent?.trim() || "";
        if (labelRegex.test(labelText)) return field;
      }
      return null;
    };
    const form = get("form");
    if (!form) return;

    // ---- Field detection (exact IDs first, then generic fallbacks) ----
    const orderId =
      get("input[id='custom#order_id']") ||
      get("input[id*='order'], input[name*='order'], textarea[id*='order'], textarea[name*='order']") ||
      getFieldByLabel(/order\s*(id|number|#)/i);

    const productName =
      get("textarea[name='custom#select_products_to_withdraw']") ||
      get("textarea[name*='product'], input[name*='product'], textarea[id*='product'], input[id*='product']") ||
      getFieldByLabel(/select\s*products|product|withdraw/i);

    const quantity = get("input[id*='quantity']");
    const fileInput = get("input[type='file']");
    const nameInput =
      get("input[id='first_name']") ||
      get("input[id*='customer'], input[id*='name'], input[name*='name']") ||
      getFieldByLabel(/^name$|full\s*name|customer\s*name/i);

    let emailInput =
      get("input[id='email']") ||
      get("input[type='email']") ||
      get("input[id*='email']");
    if (!emailInput) emailInput = getFieldByLabel(/email/i);

    const phoneInput = get("input[type='tel']");

    // ====== AUTO-FILL: order id (URL) + name + email (logged-in customer) ======
    const urlParams = new URLSearchParams(window.location.search);
    const orderParam =
      urlParams.get("order_id") ||
      urlParams.get("OrderId") ||
      urlParams.get("orderId") ||
      urlParams.get("order");

    // Native value setters — required so the form's internal (React) state actually
    // updates. Setting `el.value` directly is wiped on the next re-render (this is why
    // Order ID vanished on slower mobile hydration while Shopify's own name/email stuck).
    const nativeInputSetter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, "value")?.set;
    const nativeTextareaSetter = Object.getOwnPropertyDescriptor(HTMLTextAreaElement.prototype, "value")?.set;

    const fillField = (field, value) => {
      if (!field || value == null) return;
      const setter = field instanceof HTMLTextAreaElement ? nativeTextareaSetter : nativeInputSetter;
      if (setter) setter.call(field, value);
      else field.value = value;
      field.dispatchEvent(new Event("input", { bubbles: true }));
      field.dispatchEvent(new Event("change", { bubbles: true }));
      field.dispatchEvent(new Event("blur", { bubbles: true }));
    };

    // Use only the FIRST name for the Name field (customer can edit it freely).
    const firstNameOnly = (customerData.customer.firstName || "").trim();

    const applyAutofill = () => {
      // Order ID — Shopify never prefills this; always set from the URL param.
      if (orderId && orderParam) {
        const cleaned = orderParam.replace(/^["']|["']$/g, "").replace(/^#/, "");
        if (orderId.value.trim() !== `#${cleaned}`) fillField(orderId, `#${cleaned}`);
      }
      // Name & Email — Shopify Forms already auto-fills these for logged-in
      // customers. Only fill if STILL EMPTY, so we never duplicate its value.
      if (nameInput && firstNameOnly && !nameInput.value.trim()) fillField(nameInput, firstNameOnly);
      if (emailInput && customerData.customer.email && !emailInput.value.trim()) {
        fillField(emailInput, customerData.customer.email);
      }
    };
    // Re-apply several times: on slow (mobile) hydration the form re-renders after our
    // first fill and would otherwise wipe the Order ID. The empty-guards make repeats safe.
    applyAutofill();
    [300, 800, 1500, 2500, 4000].forEach((t) => setTimeout(applyAutofill, t));

    // ---- helpers ----
    function clampNumber(value, min, max) {
      const num = Number(value);
      if (Number.isNaN(num)) return min;
      return Math.min(Math.max(num, min), max);
    }

    const disputeProductsSelection = new Map();
    let disputeProductsSelectionOrderId = null;

    function makeDisputeItemKey(item) {
      const sku = (item?.sku || "").trim();
      const title = (item?.title || "").trim();
      return sku ? `sku:${sku.toLowerCase()}` : `title:${title.toLowerCase()}`;
    }
    function resetDisputeProductsSelectionForOrder(orderIdValue) {
      if (!orderIdValue) return;
      if (disputeProductsSelectionOrderId !== orderIdValue) {
        disputeProductsSelection.clear();
        disputeProductsSelectionOrderId = orderIdValue;
      }
    }

    function getCurrentOrderItems() {
      const enteredOrderId = (orderId?.value || "").trim();
      if (!enteredOrderId || !/^#\S+$/.test(enteredOrderId)) return null;
      if (!Array.isArray(customerData.orders) || customerData.orders.length === 0) return null;
      const norm = (id) => String(id || "").trim().replace(/^#/, "");
      const trailing = (s) => { const m = String(s || "").match(/(\d+)\s*$/); return m ? m[1] : ""; };
      const enteredNorm = norm(enteredOrderId);
      let order = customerData.orders.find((o) => o.id === enteredOrderId)
        || customerData.orders.find((o) => norm(o.id) === enteredNorm);
      if (!order) {
        const d = trailing(enteredNorm);
        if (d) { const m = customerData.orders.filter((o) => trailing(norm(o.id)) === d); if (m.length) order = m[0]; }
      }
      if (!order) return null;
      return Array.isArray(order.items) ? order.items : null;
    }

    function formatDisputeSelectionValue(arr) {
      return arr.map((x) => (x.sku ? `${x.title} - ${x.sku} (qty - ${x.qty})` : `${x.title} (qty - ${x.qty})`)).join(", ");
    }
    function getTotalQuantityFromProductFieldValue(value) {
      const matches = Array.from(String(value || "").matchAll(/\(qty\s*-\s*(\d+(?:\.\d+)?)\)/gi));
      return matches.reduce((sum, m) => sum + clampNumber(m[1], 0, Number.MAX_SAFE_INTEGER), 0);
    }
    function syncQuantityFieldFromProductField() {
      if (!quantity || !productName) return;
      fillField(quantity, String(getTotalQuantityFromProductFieldValue(productName.value)));
    }
    function setDisputeProductFieldValue(value) {
      if (!productName) return;
      fillField(productName, value);
      syncQuantityFieldFromProductField();
    }

    // ====== SELF-CONTAINED PRODUCT MODAL (no theme HTML needed) ======
    function openDisputeProductsModal() {
      const enteredOrderId = (orderId?.value || "").trim();
      if (!enteredOrderId) { validateField(orderId, "order"); return; }

      const items = getCurrentOrderItems();
      if (!items || items.length === 0) {
        showError(productName, "No products found for this order. Check the Order ID.");
        return;
      }
      resetDisputeProductsSelectionForOrder(enteredOrderId);

      const overlay = document.createElement("div");
      overlay.className = "wd-modal-overlay";
      const modal = document.createElement("div");
      modal.className = "wd-modal";

      const title = document.createElement("h3");
      title.className = "wd-modal__title";
      title.textContent = "Select products to withdraw";
      modal.appendChild(title);

      const rows = document.createElement("div");
      rows.className = "wd-modal__rows";

      items.forEach((item) => {
        const itemTitle = (item?.title || "").trim();
        const sku = (item?.sku || "").trim();
        const maxQty = clampNumber(item?.quantity ?? 0, 0, Number.MAX_SAFE_INTEGER);
        if (!itemTitle && !sku) return;
        const stored = disputeProductsSelection.get(makeDisputeItemKey(item));

        const row = document.createElement("div");
        row.className = "wd-modal__row";
        row.dataset.title = itemTitle;
        row.dataset.sku = sku;
        row.dataset.maxQty = String(maxQty);

        const checkbox = document.createElement("input");
        checkbox.type = "checkbox";
        checkbox.className = "wd-modal__check";

        const label = document.createElement("span");
        label.className = "wd-modal__label";
        label.textContent = sku ? `${itemTitle} — ${sku}` : itemTitle;

        const maxNote = document.createElement("span");
        maxNote.className = "wd-modal__max";
        maxNote.textContent = `Ordered: ${maxQty}`;

        // Quantity stepper: [−] [input] [+]  (explicit buttons so up/down always work,
        // even on themes that strip native number-input spinner arrows via CSS)
        const stepper = document.createElement("div");
        stepper.className = "wd-modal__stepper";

        const minus = document.createElement("button");
        minus.type = "button";
        minus.className = "wd-modal__step";
        minus.textContent = "−";
        minus.disabled = true;

        const qty = document.createElement("input");
        qty.type = "number";
        qty.className = "wd-modal__qty";
        qty.min = "1";
        qty.max = String(maxQty);
        qty.step = "1";
        qty.value = "1";
        qty.disabled = true;

        const plus = document.createElement("button");
        plus.type = "button";
        plus.className = "wd-modal__step";
        plus.textContent = "+";
        plus.disabled = true;

        const setQty = (v) => { qty.value = String(clampNumber(v, 1, maxQty)); };
        const setEnabled = (on) => { qty.disabled = minus.disabled = plus.disabled = !on; };

        if (stored) {
          checkbox.checked = true;
          setEnabled(true);
          setQty(stored.qty);
        }

        checkbox.addEventListener("change", () => {
          setEnabled(checkbox.checked);
          if (checkbox.checked) { setQty(qty.value); qty.focus(); }
        });
        minus.addEventListener("click", () => setQty(Number(qty.value) - 1));
        plus.addEventListener("click", () => setQty(Number(qty.value) + 1));
        qty.addEventListener("input", () => {
          const c = clampNumber(qty.value, 1, maxQty);
          if (String(c) !== String(qty.value)) qty.value = String(c);
        });

        stepper.append(minus, qty, plus);
        row.append(checkbox, label, maxNote, stepper);
        rows.appendChild(row);
      });
      modal.appendChild(rows);

      const actions = document.createElement("div");
      actions.className = "wd-modal__actions";
      const cancelBtn = document.createElement("button");
      cancelBtn.type = "button";
      cancelBtn.className = "wd-modal__btn wd-modal__btn--cancel";
      cancelBtn.textContent = "Cancel";
      const doneBtn = document.createElement("button");
      doneBtn.type = "button";
      doneBtn.className = "wd-modal__btn wd-modal__btn--done";
      doneBtn.textContent = "Done";
      actions.append(cancelBtn, doneBtn);
      modal.appendChild(actions);

      overlay.appendChild(modal);
      document.body.appendChild(overlay);

      const close = () => overlay.remove();
      overlay.addEventListener("click", (e) => { if (e.target === overlay) close(); });
      cancelBtn.addEventListener("click", close);

      doneBtn.addEventListener("click", () => {
        const selected = Array.from(rows.querySelectorAll(".wd-modal__row")).map((row) => {
          const cb = row.querySelector("input[type='checkbox']");
          const q = row.querySelector("input[type='number']");
          if (!cb || !cb.checked) return null;
          const maxQty = clampNumber(row.dataset.maxQty, 0, Number.MAX_SAFE_INTEGER);
          return { title: (row.dataset.title || "").trim(), sku: (row.dataset.sku || "").trim(), qty: clampNumber(q.value, 1, maxQty) };
        }).filter(Boolean);

        resetDisputeProductsSelectionForOrder(enteredOrderId);
        disputeProductsSelection.clear();
        selected.forEach((x) => {
          const key = x.sku ? `sku:${x.sku.toLowerCase()}` : `title:${x.title.toLowerCase()}`;
          disputeProductsSelection.set(key, { qty: x.qty });
        });
        setDisputeProductFieldValue(formatDisputeSelectionValue(selected));
        close();
      });
    }

    // Make the products field a read-only "click to open modal" trigger
    if (productName && !productName._disputeProductsModalBound) {
      productName._disputeProductsModalBound = true;
      productName.readOnly = true;
      productName.setAttribute("inputmode", "none");
      productName.style.caretColor = "transparent";
      productName.style.cursor = "pointer";
      productName.addEventListener("keydown", (e) => e.preventDefault());
      productName.addEventListener("paste", (e) => e.preventDefault());
      productName.addEventListener("click", (e) => { e.preventDefault(); openDisputeProductsModal(); });
      productName.addEventListener("input", () => syncQuantityFieldFromProductField());
    }

    function validateField(field, type) {
      const val = (field?.value || "").trim();
      clearError(field);
      const container = field?.closest("._formFieldContainer_1mxsl_5") || field?.closest("._formFileInput_ehvsf_1") || field?.parentElement;
      const fieldLabel = container?.querySelector("label, p._textBody_2aowh_10")?.textContent?.toLowerCase() || "";
      const isAdditionalComment = fieldLabel.includes("additional") && (fieldLabel.includes("comment") || fieldLabel.includes("comments"));
      const isRequired = !isAdditionalComment;

      switch (type) {
        case "order":
          if (!val && isRequired) { showError(field, "Order ID is required"); return false; }
          if (!val) return true;
          if (!/^#\S+$/.test(val)) { showError(field, "Order ID must start with #"); return false; }
          if (!Array.isArray(customerData.orders) || customerData.orders.length === 0) return true;
          if (!getCurrentOrderItems()) { showError(field, "Order ID not found in your account orders"); return false; }
          return true;

        case "product":
          if (!val && isRequired) { showError(field, "Please select at least one product"); return false; }
          if (!val) return true;
          const enteredOrderId = (orderId?.value || "").trim();
          if (!enteredOrderId || !/^#\S+$/.test(enteredOrderId)) { showError(field, "Please enter a valid Order ID first"); return false; }
          return true;

        case "email":
          const expectedEmail = (customerData.customer.email || "").trim().toLowerCase();
          const enteredEmail = val.toLowerCase();
          if (!enteredEmail) { showError(field, "Email is required"); return false; }
          if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(enteredEmail)) { showError(field, "Enter a valid email address"); return false; }
          if (expectedEmail && enteredEmail !== expectedEmail) { showError(field, `Email must match your logged-in account (${expectedEmail})`); return false; }
          return true;

        case "phone":
          if (!val && isRequired) { showError(field, "Phone number is required"); return false; }
          if (!val) return true;
          if (!/^\+?\d{7,15}$/.test(val.replace(/\s/g, ""))) { showError(field, "Please enter a valid phone number"); return false; }
          return true;

        case "dropdown":
          const btn = field;
          const value = btn.textContent.trim();
          const dropdownContainer = btn.closest("._selectContainer_12thd_6");
          const dropdownLabel = dropdownContainer?.querySelector("p._label_12thd_10")?.textContent || "This field";
          const existingError = dropdownContainer?.querySelector(".field-error-js");
          if (existingError) existingError.remove();
          if (!value || value === "Select" || value === dropdownLabel || value === btn.getAttribute("placeholder")) {
            const err = document.createElement("div");
            err.className = "field-error-js";
            err.style.color = "#e02229"; err.style.fontSize = "13px"; err.style.marginTop = "8px";
            err.textContent = "Please select an option";
            dropdownContainer?.appendChild(err);
            btn.style.border = "1px solid #e02229";
            return false;
          }
          btn.style.border = "1px solid rgba(255,255,255,0.2)";
          return true;

        default:
          return true;
      }
    }

    // ---- Real-time listeners ----
    if (orderId) { orderId.addEventListener("input", () => validateField(orderId, "order")); orderId.addEventListener("blur", () => validateField(orderId, "order")); }
    if (productName) { productName.addEventListener("blur", () => validateField(productName, "product")); }
    // Name is intentionally NOT validated — customer may edit it to any preferred name.
    if (emailInput) { emailInput.addEventListener("input", () => validateField(emailInput, "email")); emailInput.addEventListener("blur", () => validateField(emailInput, "email")); }
    if (phoneInput) phoneInput.addEventListener("input", () => validateField(phoneInput, "phone"));

    const dropdownButtons = Array.from(root.querySelectorAll("button._selectToggle_12thd_25"))
      .filter((btn) => !btn.closest("._formPhoneInputContainer_piv1u_6"));
    dropdownButtons.forEach((btn) => {
      btn.addEventListener("click", () => setTimeout(() => validateField(btn, "dropdown"), 300));
      btn.addEventListener("blur", () => validateField(btn, "dropdown"));
    });

    function runAllValidations() {
      root.querySelectorAll(".field-error-js").forEach((n) => n.remove());
      let valid = true;
      if (orderId && !validateField(orderId, "order")) valid = false;
      if (productName && !validateField(productName, "product")) valid = false;
      if (emailInput && !validateField(emailInput, "email")) valid = false;
      if (phoneInput && !validateField(phoneInput, "phone")) valid = false;
      dropdownButtons.forEach((btn) => { if (!validateField(btn, "dropdown")) valid = false; });
      return valid && !root.querySelector(".field-error-js");
    }

    const submitBtn = form.querySelector('button[type="submit"], input[type="submit"]');
    if (submitBtn) {
      submitBtn.addEventListener("click", (e) => {
        if (!runAllValidations()) {
          e.preventDefault(); e.stopPropagation();
          const firstErr = root.querySelector(".field-error-js");
          if (firstErr) firstErr.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      }, true);
    }
    form.addEventListener("submit", (e) => { if (!runAllValidations()) { e.preventDefault(); e.stopPropagation(); } }, true);
  }

  initValidation();
})();
